import { ForwardedRef, useCallback, useLayoutEffect, useRef } from 'react';

export default function useIndeterminate(
  indeterminate: boolean,
  ref: ForwardedRef<HTMLInputElement>,
) {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const setInputRef = useCallback(
    (input: HTMLInputElement | null) => {
      inputRef.current = input;

      if (typeof ref === 'function') ref(input);
      else if (ref) ref.current = input;
    },
    [ref],
  );

  const syncIndeterminate = useCallback(() => {
    if (inputRef.current) inputRef.current.indeterminate = indeterminate;
  }, [indeterminate]);

  useLayoutEffect(syncIndeterminate);

  return { setInputRef, syncIndeterminate };
}
